import { ref, computed } from 'vue'

const STORAGE_KEY = 'metrika_debug_enabled'

const isMetrikaEnabled = ref(true)

if (typeof window !== 'undefined') {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved !== null) {
    isMetrikaEnabled.value = saved === 'true'
  }
}

const toggleMetrikaDebug = (force = null) => {
  if (typeof window === 'undefined') return

  isMetrikaEnabled.value = force !== null ? force : !isMetrikaEnabled.value
  localStorage.setItem(STORAGE_KEY, String(isMetrikaEnabled.value))

  console.log(
    `🧪 Яндекс.Метрика: ${isMetrikaEnabled.value ? '🟢 ВКЛЮЧЕНА' : '🔴 ОТКЛЮЧЕНА'}`,
    isMetrikaEnabled.value ? 'Данные отправляются' : 'Режим отладки'
  )

  return isMetrikaEnabled.value
}

/**
 * @typedef {Object} MetrikaDebugInfo
 * @property {boolean} debug_enabled
 * @property {boolean} available
 */

/**
 * Composable для работы с Яндекс.Метрикой
 * @returns {{ hit: (url?: string) => void, reachGoal: (target: string, params?: Object) => void, getDebugInfo: () => MetrikaDebugInfo, toggle: (force?: boolean | null) => boolean, isDebugEnabled: import('vue').ComputedRef<boolean> }}
 */
export const useMetrika = () => {
  const counterId = 103926607 // в env

  const isAvailable = () => {
    return typeof window !== 'undefined' &&
           typeof window.ym === 'function'
  }

  const isProd = () => {
    return import.meta.env?.MODE === 'production' ||
           import.meta.env?.VITE_APP_ENV === 'production'
  }

  /** @param {string|null} [url] */
  const hit = (url = null) => {

    if (!isProd() && isMetrikaEnabled.value) {
      const href = typeof window !== 'undefined' ? window.location.href : ''
      console.log('📊 [METRIKA DEBUG] hit:', url || href)
    }

    if(!isAvailable()){
      return;
    }

    try {
      const targetUrl = url ?? (typeof window !== 'undefined' ? window.location.href : '')
      window.ym(counterId, 'hit', targetUrl)
    } catch (e) {
      console.warn('Yandex.Metrika hit error:', e)
    }
  }

  /** @param {string} target @param {Object} [params] */
  const reachGoal = (target, params = {}) => {

    if (!isProd() && isMetrikaEnabled.value) {
      console.log('🎯 [METRIKA DEBUG] reachGoal:', target, params)
    }

    if(!isAvailable()){
      return;
    }

    try {
      if (Object.keys(params).length > 0) {
        window.ym(counterId, 'reachGoal', target, params)
      } else {
        window.ym(counterId, 'reachGoal', target)
      }
    } catch (e) {
      console.warn('Yandex.Metrika goal error:', e)
    }
  }

  /** @returns {MetrikaDebugInfo} */
  const getDebugInfo = () => ({
    debug_enabled: isMetrikaEnabled.value,
    available: isAvailable()
  })

  return {
    hit,
    reachGoal,
    getDebugInfo,
    toggle: toggleMetrikaDebug,
    isDebugEnabled: computed(() => isMetrikaEnabled.value)
  }
}